/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityDataleaksStandardResult } from './ControlEntityDataleaksStandardResult';
import {
    ControlEntityDataleaksStandardResultFromJSON,
    ControlEntityDataleaksStandardResultFromJSONTyped,
    ControlEntityDataleaksStandardResultToJSON,
} from './ControlEntityDataleaksStandardResult';

/**
 * 
 * @export
 * @interface ControlEntityDataleaksStandardResponse
 */
export interface ControlEntityDataleaksStandardResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlEntityDataleaksStandardResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityDataleaksStandardResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityDataleaksStandardResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityDataleaksStandardResult>}
     * @memberof ControlEntityDataleaksStandardResponse
     */
    results: Array<ControlEntityDataleaksStandardResult>;
}

/**
 * Check if a given object implements the ControlEntityDataleaksStandardResponse interface.
 */
export function instanceOfControlEntityDataleaksStandardResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlEntityDataleaksStandardResponseFromJSON(json: any): ControlEntityDataleaksStandardResponse {
    return ControlEntityDataleaksStandardResponseFromJSONTyped(json, false);
}

export function ControlEntityDataleaksStandardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityDataleaksStandardResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': ((json['results'] as Array<any>).map(ControlEntityDataleaksStandardResultFromJSON)),
    };
}

export function ControlEntityDataleaksStandardResponseToJSON(value?: ControlEntityDataleaksStandardResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlEntityDataleaksStandardResultToJSON)),
    };
}

